module.exports = __webpack_public_path__ + "static/img/usb-soundstick.8a2a146.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/usb-soundstick.jpg
// module id = 304
// module chunks = 0